// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"962d3b76","239":"e75639ec","455":"61488d82","488":"652a3b40","952":"6cd6268a"}[chunkId] + ".chunk.js";
};